import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import useContextTournament from '../useContextTournament';


export default function SetCode(props) {

    const navigate = useNavigate();
    const { contextTournament, associationCode, tournamentId, reloadContextTournament, loadContextTournament } = useContextTournament();
    const { tournamentCode } = useParams();

    const [tournament, setTournament] = useState([]);


    useEffect(() => {
        //getData();
        if (tournamentCode) {
            const loadedTournament = loadContextTournament(tournamentCode);
            setTournament(loadedTournament);
            navigate("/");
        }

    }, [tournamentCode]);
    useEffect(() => {
        //getData();
    }, [associationCode, tournamentId])

    return (
        <>
            <div className="container-xl px-2 pb-4">
                {contextTournament ?
                    <div className="p-5 bg-body-tertiary rounded-3 m-3">
                        Redirecting to the tournament page...
                    </div>
                    :
                    <div className="row mb-3 dashboard justify-content-center text-center">
                        <h2>Loading tournament...</h2>
                        <FontAwesomeIcon icon={faSpinner} spin className="ms-2 fs-1" />
                        <p className="lead text-muted">Tournament Code: {tournamentCode}</p>
                        {/*<Link to="/" className="link-secondary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover h3" onClick={reloadContextTournament}>Reload</Link>*/}
                    </div>
                }
            </div>
        </>
    );

}

